import { DataFormats } from '@skylab-shared/constants';
import { HttpService, Query, QueryHandler, TaggedUrl, Tags } from '@skylab-shared/core';
import { MS_PER_MINUTE } from '@skylab-shared/utils';
import { format } from 'fecha';

export interface ReportInventoryStocktakingParameters {
    search: string;
    date: Date;
    inventoryId: number;
}

export interface ReportInventoryStocktakingGridItem {
    no: number;
    cost: number;
    currencyPrecision: number;
    currencySymbol: string;
    productId: number;
    productName: string;
    quantity: number;
    unitCost: number;
    unitSymbol: string;
}

export class ReportInventoryStocktakingGridQuery extends Query<ReportInventoryStocktakingGridItem[]> {
    public constructor (public readonly parameters: ReportInventoryStocktakingParameters) {
        super();
    }
}

export class ReportInventoryStocktakingGridQueryHandlerBase implements QueryHandler<ReportInventoryStocktakingGridQuery, ReportInventoryStocktakingGridItem[]> {
    private static Url = TaggedUrl.join('inventoryStocktaking', [Tags.Api]);

    public constructor(
        private readonly http: HttpService
    ) {}

    public async handleAsync(query: ReportInventoryStocktakingGridQuery): Promise<ReportInventoryStocktakingGridItem[]> {
        const { data } = await this.http.get<ReportInventoryStocktakingGridItem[]>(ReportInventoryStocktakingGridQueryHandlerBase.Url, {
            params: {
                ...query.parameters,
                date: query.parameters.date && format(query.parameters.date, DataFormats.date.webApi),
                inventoryId: query.parameters.inventoryId
            },
            timeout: 3 * MS_PER_MINUTE
        });

        return data;
    }
}
